import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <PopularSection />
        <LatestSection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}